import { Link } from 'react-router-dom';

import { GIFT_PARTNER_TEST_PATH } from '../tester/giftPartnerTestClient';

import './giftPartnerGuide.css';

// 가이드 본문(GiftPartnerGuide)은 로그인 뒤에만 불러오는 별도 코드 조각이다.
// 경로·안내 카드처럼 다른 화면이 쓰는 것만 여기 둬서 본문이 메인 번들에 딸려 들어가지 않게 한다.
export const GIFT_PARTNER_GUIDE_PATH = '/gift-brand/api-integration/guide';

export const GiftPartnerGuideResources = () => (
  <section className="partner-guide-resources" aria-label="API 개발 가이드">
    <div>
      <strong>연동 전에 개발 가이드를 확인하세요</strong>
      <p>
        키·IP 확인부터 웹훅 없는 폴링 연동, 이미지 테스트와 실제 서버 전환까지 순서대로
        확인하세요.
      </p>
    </div>
    <div className="partner-guide-links">
      <Link to={GIFT_PARTNER_GUIDE_PATH}>개발 가이드 보기 →</Link>
      <Link to={GIFT_PARTNER_TEST_PATH}>발급받은 키로 API 테스트 →</Link>
    </div>
  </section>
);
